import React from "react";
import PostData from "../../packs_helper/scripts/PostData";

class ConfirmationForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			email: "",
			captcha_code: "",
			contract: "",
		};

		this.SendConfirmation = this.SendConfirmation.bind(this);
		this.KeyDownHandler = this.KeyDownHandler.bind(this);
		this.SwitchToSignIn = this.SwitchToSignIn.bind(this);
		this.SwitchToPasswordReset = this.SwitchToPasswordReset.bind(this);
	}

	componentDidMount(){
		if(this.props.email){
			this.setState({email: this.props.email});
		}

	}

	SendConfirmation(e) {
		e.preventDefault();

		const { email, captcha_code, contract } = this.state;

		const params = {
			email,
			captcha_code,
			contract,
		};

		if (!contract) {
			ShowPopup({
				title: "Sistem Mesajı!",
				message:
					"Üyelik onaylama talimatlarının e-posta adresinize gönderilmesini onaylayın!",
			});
			this.setState({ waitForResponse: false });
			return false;
		}

		this.setState({ waitForResponse: true });
		PostData(this.props.sendConfirmationPath, params)
			.then((response) => {


				if (!response.state) {
					this.props.RefreshCaptchaCode();
				}
				else{
					this.props.ActivateTab('sign-in');
				}
			})
			.catch((err) => {


			});
	}

	KeyDownHandler(e){
		const keyCode = e.key || e.code;
		if(keyCode === 'Enter'){
			this.Login(e);
		}
	}

	SwitchToSignIn(){
		this.props.ActivateTab('sign-in')
	}

	SwitchToPasswordReset(){
		this.props.ActivateTab('password-reset')
	}

	render() {
		return (
			<React.Fragment>
				<input
					type="text"
					name="email"
					value={this.state.email}
					onInput={(e) => this.setState({ email: e.target.value })}
					onKeyDown={this.KeyDownHandler}
					placeholder="E-Posta Adresi:"
					autoFocus
				/>

				<div className="input-with-captcha">
					<input
						type="text"
						name="captcha_code"
						value={this.state.captcha_code}
						onInput={(e) => this.setState({ captcha_code: e.target.value })}
						onKeyDown={this.KeyDownHandler}
						maxLength={4}
						placeholder="Güvenlik Kodu:"
					/>
					<img src={this.props.captchaImage} />
					<button onClick={this.props.RefreshCaptchaCode}>
						<svg className="icon">
							<use xlinkHref="#gs-icon-sign-box-reload"></use>
						</svg>
					</button>
				</div>

				<div className="checkbox">
					<input
						type="checkbox"
						name="contract"
						id="contract"
						value="1"
						checked={this.state.contract}
						onChange={(e) => this.setState({ contract: e.target.checked })}
					/>
					<label htmlFor="contract">Üyelik onaylama talimatlarını gönder.</label>
				</div>

				<button className="btn btn-blue" onClick={this.SendConfirmation}>
					Gönder
				</button>
				<button className="btn btn-default" onClick={this.SwitchToSignIn}>Giriş Yap</button>
				<button className="btn btn-default" onClick={this.SwitchToPasswordReset}>Şifremi Unuttum</button>

			</React.Fragment>
		);
	}
}

export default ConfirmationForm;
